module.exports = __webpack_public_path__ + "static/media/bushaltestelle.4ad20e50.svg";